(function () {
  var inquiryStorageKey = 'aoy_special_project_inquiry_klaviyo';
  var klaviyoSiteId = 'VXRF48';
  var marketingListId = 'TsmJtt';
  var klaviyoRevision = '2026-07-15';
  var pendingLifetime = 60 * 60 * 1000;

  function createInquiryId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    return 'aoy-special-project-' + Date.now() + '-' + Math.random().toString(36).slice(2);
  }

  function fieldValue(form, selector) {
    var field = form.querySelector(selector);
    return field && typeof field.value === 'string' ? field.value.trim() : '';
  }

  function storePendingInquiry(form, marketingConsent) {
    var email = fieldValue(form, '#special-project-email');
    if (!email) return;

    try {
      window.sessionStorage.setItem(inquiryStorageKey, JSON.stringify({
        inquiryId: createInquiryId(),
        createdAt: Date.now(),
        email: email,
        marketingConsent: Boolean(marketingConsent && marketingConsent.checked),
        projectType: fieldValue(form, '#special-project-type'),
        projectLocation: fieldValue(form, '#special-project-location'),
        desiredTiming: fieldValue(form, '#special-project-timing'),
        budgetRange: fieldValue(form, '#special-project-budget')
      }));
    } catch (error) {
      // Storage failure must never interrupt Shopify's native contact form submission.
    }
  }

  function sendKlaviyoRequest(endpoint, body) {
    return fetch('https://a.klaviyo.com/client/' + endpoint + '?company_id=' + encodeURIComponent(klaviyoSiteId), {
      method: 'POST',
      headers: {
        Accept: 'application/vnd.api+json',
        'Content-Type': 'application/vnd.api+json',
        revision: klaviyoRevision
      },
      body: JSON.stringify(body),
      keepalive: true
    }).then(function (response) {
      if (!response.ok) throw new Error('Klaviyo ' + endpoint + ' request failed with HTTP ' + response.status);
    });
  }

  function logKlaviyoSuccess(action) {
    console.info('[Art of Yost] Klaviyo Special Project ' + action + ' succeeded.');
  }

  function logKlaviyoFailure(action, error) {
    console.error('[Art of Yost] Klaviyo Special Project ' + action + ' failed.', error);
  }

  function sendInquiryEvent(inquiry) {
    return sendKlaviyoRequest('events', {
      data: {
        type: 'event',
        attributes: {
          properties: {
            'Project Type': inquiry.projectType,
            'Project Location': inquiry.projectLocation,
            'Desired Timing': inquiry.desiredTiming,
            'Budget Range': inquiry.budgetRange
          },
          unique_id: inquiry.inquiryId,
          metric: {
            data: {
              type: 'metric',
              attributes: { name: 'Special Project Inquiry Submitted' }
            }
          },
          profile: {
            data: {
              type: 'profile',
              attributes: { email: inquiry.email }
            }
          }
        }
      }
    });
  }

  function recordEmailConsent(inquiry) {
    return sendKlaviyoRequest('subscriptions', {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Special Project Inquiry',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: inquiry.email,
                subscriptions: {
                  email: {
                    marketing: { consent: 'SUBSCRIBED' }
                  }
                }
              }
            }
          }
        },
        relationships: {
          list: {
            data: { type: 'list', id: marketingListId }
          }
        }
      }
    });
  }

  function subscribeEmailToMarketingList(inquiry) {
    var body = new URLSearchParams();
    body.set('g', marketingListId);
    body.set('email', inquiry.email);

    return fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: body.toString(),
      keepalive: true
    }).then(function (response) {
      if (!response.ok) throw new Error('Klaviyo Email List request failed with HTTP ' + response.status);
      return response.json();
    }).then(function (result) {
      if (!result || result.success !== true) {
        var errors = result && Array.isArray(result.errors) ? result.errors.join(', ') : 'Unknown response';
        throw new Error('Klaviyo Email List request was rejected: ' + errors);
      }
      return result;
    });
  }

  function processPendingInquiry() {
    if (!document.querySelector('[data-aoy-special-project-inquiry-received]')) return;

    var inquiry;
    try {
      var storedInquiry = window.sessionStorage.getItem(inquiryStorageKey);
      if (!storedInquiry) return;
      window.sessionStorage.removeItem(inquiryStorageKey);
      inquiry = JSON.parse(storedInquiry);
    } catch (error) {
      try { window.sessionStorage.removeItem(inquiryStorageKey); } catch (storageError) {}
      return;
    }

    if (!inquiry || !inquiry.email || !inquiry.inquiryId) return;
    if (!inquiry.createdAt || Date.now() - inquiry.createdAt > pendingLifetime) return;

    sendInquiryEvent(inquiry).then(function () {
      logKlaviyoSuccess('inquiry event');
    }).catch(function (error) {
      logKlaviyoFailure('inquiry event', error);
    });

    if (inquiry.marketingConsent === true) {
      recordEmailConsent(inquiry).then(function () {
        logKlaviyoSuccess('email consent');
      }).catch(function (error) {
        logKlaviyoFailure('email consent', error);
      });

      subscribeEmailToMarketingList(inquiry).then(function () {
        logKlaviyoSuccess('Email List subscription');
      }).catch(function (error) {
        logKlaviyoFailure('Email List subscription', error);
      });
    }
  }

  function initSpecialProjectForm(form) {
    if (!form || form.dataset.aoySpecialProjectReady === 'true') return;
    form.dataset.aoySpecialProjectReady = 'true';

    var marketingConsent = form.querySelector('[data-aoy-special-project-marketing-consent]');
    var marketingConsentValue = form.querySelector('[data-aoy-special-project-marketing-consent-value]');

    function syncMarketingConsent() {
      if (marketingConsentValue) marketingConsentValue.value = marketingConsent && marketingConsent.checked ? 'Yes' : 'No';
    }

    if (marketingConsent) marketingConsent.addEventListener('change', syncMarketingConsent);

    form.addEventListener('submit', function () {
      syncMarketingConsent();
      storePendingInquiry(form, marketingConsent);
    });
  }

  function initAll() {
    document.querySelectorAll('#special-project-inquiry-form').forEach(initSpecialProjectForm);
    processPendingInquiry();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
